import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "./TestShow.css";
import Subscriptions from '../Subscriptions/Subscriptions';
import { END_URL } from "../../config";
import buttonloader from "../../images/buttonloader.gif";
import loadimg from "../../images/loader_wish.gif";
import SubscriptionSkeleton from '../Subscriptions/SubscriptionSkeleton';
import gg from "../../images/pp-logo.gif"; 

function TestShow({onLoginChange,userdetail,token}) {

    const subS = true;

    const [subscription, setSubscription] = useState(null);

    const [loading, setLoading] = useState(true);

    const queryParams = new URLSearchParams(window.location.search);

    const insufficient = queryParams.get("payment") === "failed";

    const reason = queryParams.get("reason");

    const url = queryParams.get("url");

    const sub_id = queryParams.get("sub_id");

    useEffect(() => {

         window.scrollTo({ top: 0, behavior: "smooth" });
         
        setLoading(true);

        const fetchSubscriptionDetail = async () => {
            try {
                
                const response = await axios.get(`${END_URL}/get-subcription`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                setSubscription(response.data);

                setLoading(false);

            } catch (error) {
                console.log('Error fetching subscription:', error);
            }
        };

        fetchSubscriptionDetail();
    }, []);

    if (loading) {
        return (
        <div
            className="loadingDiv"
        >
            <img
            src={gg}
            alt="Loading..."
            
            />
        </div>
        );
    }

    return (
        <div className="test-show-main">
            <div className="container">
                <div className="row">
                  
                     <Subscriptions url={url} sub_id={sub_id} reason={reason}  insufficientPayment={insufficient} subs={subS} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                </div>
            </div>
        </div>
    );
}

export default TestShow;
